var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',{attrs:{"disabled":_vm.disabled(),"value":_vm.value,"max":_vm.max,"min":_vm.min,"lazy":true,"interval":_vm.interval,"width":"100%","height":"8px","process":false},on:{"change":_vm.update},scopedSlots:_vm._u([{key:"dot",fn:function(ref){
var focus = ref.focus;
return [_c('div',{class:['custom-dot', { focus: focus }]})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }